import React from 'react'
import axios from 'axios';
import SortableItem from './SortableItem'

export default class SortableAddons extends React.Component {

  state = {
    items: this.props.items
  };

  onSortItems = (items) => {
    this.setState({
      items: items
    });
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      axios.patch("/admin/addons/reorder", {
        items: this.state.items
      })
    }, 2000)
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  render() {
    const { items } = this.state;
    var listItems = items.map((item, i) => {
      return (
        <SortableItem
          key={i}
          onSortItems={this.onSortItems}
          items={items}
          sortId={i}
          item={item}
        />
      )
    })

    return (
      <table style={{ minWidth: '60%' }}>
        <thead>
        <tr>
          <th>Is Senior</th>
          <th>Is General</th>
          <th>Is For Gifts</th>
          <th>Name</th>
          <th>Price with</th>
          <th>Price without</th>
          <th>Image count</th>
          <th>CSS Name</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
          {listItems}
        </tbody>
      </table>
    )
  }
}
